import "../../../field.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.PatientStep ??= {};

AppointmentBooking.Wizard.Views.PatientStep.MyChartPatientProxyField = class MyChartPatientProxyField extends (
  AppointmentBooking.Wizard.Views.Field
) {
  constructor() {
    super(...arguments);
  }

  // EVENT HANDLERS

  handlePatientProxyChange(event) {
    const option = jQuery(event.currentTarget).find("option:selected");

    return this.model.set({
      patient_id: option.data("id"),
      patient_id_type: option.data("id-type"),
      date_of_birth: this.model.constructor.normalizeDateOfBirth(option.data("date-of-birth")),
    });
  }
};
AppointmentBooking.Wizard.Views.PatientStep.MyChartPatientProxyField.prototype.template =
  "step/patient/fields/mychart_patient_proxy";
AppointmentBooking.Wizard.Views.PatientStep.MyChartPatientProxyField.prototype.className =
  "appointment-booking-wizard-patient-step-mychart-patient-proxy-field";
AppointmentBooking.Wizard.Views.PatientStep.MyChartPatientProxyField.prototype.events = {
  "change select": "handlePatientProxyChange",
};
